import angular from 'angular';

import '../../core/main/controller/environment';
import '../../main/factory/geocoder';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.map", [
]).controller("merchant.application.module.map.controller", [
    "$scope", "$controller", "$sce",
    "core.application.main.controller.environment",
    "merchant.application.main.factory.geocoder",
    function($scope, $controller, $sce, Environment, Geocoder) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        var mapUrl = Environment.MAP_URL;
        var apiKey = Environment.GOOGLEMAPS_API_KEY;

        $scope.model.displayLocationChooser = false;
        $scope.model.mapAddressResolved = false;
        $scope.model.unresolvedAddress = false;

        $scope.renderMap = function(address) {
            var trustedResourceUrl = mapUrl + apiKey + "&q=" + address;
            $scope.model.googleMapsUrl = $sce.trustAsResourceUrl(trustedResourceUrl);
            $scope.model.mapAddressResolved = true;
        };

        Geocoder.parseAddress({"address": $scope.model.mapAddress},
            function(results) {
                if (results.length === 1) {
                    // render the map immediately if there is only one resolved address
                    $scope.renderMap($scope.model.mapAddress);
                    $scope.$apply();
                } else {
                    // if there are more than one resolved addresses, display the addresses for the user to choose
                    $scope.model.displayLocationChooser = true;
                    $scope.model.mapLocations = results;
                    $scope.$apply();
                }
            },
            function() {
                $scope.model.unresolvedAddress = true;
                $scope.$apply();
            }
        );
    }
]);
